import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiPencilSimpleLine } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { PopupActions } from 'reactjs-popup/dist/types';
import {
  useDeleteDigitalDistributionTemplate,
  useGetDigitalDistributionSectionTemplate,
} from 'services/templates/digital-distribution-template';
import { TEMPLATE_TYPE } from 'services/templates/types';
import { contractTemplateUtil } from 'utils';
import { onErrorShowToast } from 'utils/service/errorHandler';

const DigitalDistributionTemplateSection = () => {
  const id = useParamId('/templates-extended');

  const { t } = useTranslation();
  const navigate = useNavigate();

  const digitalDistribution = useGetDigitalDistributionSectionTemplate(id);

  const removeDigitalDistribution = useDeleteDigitalDistributionTemplate(id);

  const onRemoveDigitalDistributionTemplate = async (actions: PopupActions) => {
    await removeDigitalDistribution.mutateAsync(undefined, {
      onError: error => {
        actions.close();
        onErrorShowToast(error);
      },
      onSuccess: () => navigate('/templates-extended'),
    });
  };

  return (
    <Form.Contract
      tittle={
        digitalDistribution.data?.title ??
        t('contract-template.digitalDistribution.title')
      }
      backPath='templates-extended'
      topbarContent={
        <div className='flex'>
          <Button
            isClear
            onlyIcon
            onClick={() =>
              navigate(`/templates-extended/digital-distribution/edit/${id}/form`, {
                replace: true,
              })
            }>
            <Button.Icon icon={<PiPencilSimpleLine />} />
          </Button>
          <MagellanPopups.DeleteWarning
            onRemove={onRemoveDigitalDistributionTemplate}
            removeLoading={digitalDistribution.isPending}
            name={digitalDistribution.data?.title}
          />
        </div>
      }
      initialStatus={{
        ...contractTemplateUtil.distribution.initialStatus,
        displayMode: true,
      }}
      initialValues={{
        ...contractTemplateUtil.form.initialValues,
        items: digitalDistribution.data
          ? middleware.template.digitalDistribution.queryToForm(
              digitalDistribution.data,
              '1',
              true,
              true
            )
          : contractTemplateUtil.distribution.initialValues(TEMPLATE_TYPE.digitalDistribution),
      }}
      onSubmit={() => {}}
      status={{ isLoading: digitalDistribution.isLoading, displayMode: true }}
    />
  );
};

export default DigitalDistributionTemplateSection;
